import { Meta } from "@/shared/components";
import { Queues } from "@/admin/features/queues";

/**
 * Страница реестра очередей
 */
export function QueuesPage() {
  return (
    <>
      <Meta title="Очереди" />
      <Queues />
    </>
  );
}
